export default __webpack_public_path__ + "static/media/icon.scrims.7eba8cde.svg";